import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Utente } from './main/_models/utente';
import { Router } from '@angular/router';
import { AuthenticationService } from './root/_services/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { SpinnerService } from './root/_services/spinner.service';
import { CheckProfileService } from './root/_services/check-profile.service';
import { ItmModalComponent } from './shared/ui-component/itm-modal/itm-modal.component';
import { AppConfig } from './app.config';
import { ResponsiveService } from './root/_services/responsive.service';
import { AlertService } from './root/_services/alert.service';
import * as moment from 'moment';

declare var $: any;

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {

	@ViewChild("modalWarning") modalWarning: ItmModalComponent;

	versione: string;
	versioneBE: string;
	year: string;

	currentUser: Utente;
	showLoading = true;
	profileData: ProfileData = { "messages": [], "showWarning": false };

	constructor(
		private router: Router,
		private config: AppConfig,
		private authenticationService: AuthenticationService,
		private translateService: TranslateService,
		private spinnerService: SpinnerService,
		private checkprofileService: CheckProfileService,
		private responsiveService: ResponsiveService,
		private alertService: AlertService
	) {
		this.authenticationService.currentUser.subscribe(u => this.currentUser = u);
		this.translateService.setDefaultLang('it');
		this.spinnerService.change.subscribe((value) => this.showLoading = value.show);
	}
	ngAfterViewInit(): void {
		this.setMinHeight();
		window.addEventListener("resize", () => { this.setMinHeight(); });
	}

	get menu() {
		return this.currentUser ? this.currentUser.menu : {};
	}

	ngOnInit() {
		this.versione = this.config.getVersion("semverString");
		this.checkprofileService.getMessages();
		this.checkprofileService.checkProfileData.subscribe(
			x => {
				this.profileData.showWarning = x.warningCheckProfile;
				this.profileData.messages = x.messages;
			});
		this.year = moment().format("Y");
		this.authenticationService.getBackendVersion().subscribe(x => {
			if(x.status == "OK")
				this.versioneBE = x.result;
			else
				this.alertService.error(x.error_message ? x.error_message : "System error");
		});
	}

	setMinHeight() {
		const h = (window.innerHeight - $("nav.site-header").innerHeight() - $("footer").innerHeight());
		$(".main").css("min-height", h);
		// if ($(".page-container").position()) {
		// 	const ft = $("footer").position().top;
		// 	const ct = $(".page-container").position().top;
		// 	const h2 = ft - ct - 10;
		// 	console.log(ft);
		// 	console.log(ct);
		// 	if (h2 < h)
		// 		$(".page-container").css("min-height", h2);
		// }
		this.responsiveService.setCurrentBreakpoint(window.outerWidth);
	}

	logout() {
		this.authenticationService.logout(true);
		this.router.navigate(['/login']);
	}

	ngOnDestroy() {
		this.checkprofileService.checkProfileData.unsubscribe();
	}

	showWarning() {
		this.modalWarning.show();
	}

	toggleMenu() {
		$('.navbar-collapse').collapse('hide');
	}
}

export interface ProfileData {
	showWarning: boolean;
	messages: Array<string>;
};
